import { useState, useEffect } from "react";
import "./FormTheme.css";
import { FormThemeExtended } from "effno-core";
import FormThemeMenu from "./FormThemeMenu";

type FormThemeProps = {
    formTheme: FormThemeExtended;
    isSelected: boolean;
    onChange: (formThemeId: string) => void;
    onEdit: (formThemeId: string) => void;
    onDelete: (formThemeId: string) => void;
    onUnselect: () => void;
}

export const FormTheme = ({formTheme, isSelected, onChange, onEdit, onDelete, onUnselect} : FormThemeProps) => {

    const settings = formTheme.settings ? JSON.parse(formTheme.settings) : {};

    const handlePossibleChange = () => {
        if (!isSelected) {
            onChange(formTheme.id);
        }
    }

    return (
        <div 
            className={"form-theme" + (isSelected ? " form-theme-selected" : "")}
            onClick={handlePossibleChange}
            onDoubleClick={() => onEdit(formTheme.id)}
            style={{
                ...(settings.backgroundImage ? 
                    {
                        backgroundImage: `url(${settings.backgroundImage})`,
                        objectFit: "cover",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center top"
                    } : {}),
                backgroundColor: settings.backgroundColor,
                color: settings.questionColor,
                fontFamily: settings.font,
                // outlineColor: settings.answerColor,
                // borderColor: settings.borderColor
            }}
        >
            {formTheme.name}
            <div className="form-theme-menu-container">
                <FormThemeMenu
                    formThemeId={formTheme.id}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onUnselect={isSelected ? onUnselect : undefined}
                />
            </div>
        </div>
    )
}